<template>
    <div>
        <UiCardListHeader
            :title="lang('attention::attention.widgets.active_attentions.title')"
            :action-href="route('attention.admin.index')"
            :action-label="lang('attention::attention.actions.manage')"
        />

        <UiCardEmpty v-if="attentions.length === 0">
            {{ lang('attention::attention.widgets.active_attentions.no_attentions') }}
        </UiCardEmpty>
        <UiCardList
            v-else
            as="transition-group"
            name="slide-fade"
            enter-active-class="transition duration-300 ease-out transform"
            enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-20"
            enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
            leave-active-class="transition duration-100 ease-in"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <attention-preview
                v-for="attention in attentions"
                :key="attention.id"
                :attention="attention"
            ></attention-preview>
        </UiCardList>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import AttentionPreview from '@src/Attention/Pages/Attention/AttentionPreview.vue';

const attentions = ref([]);

const load = () => {
    axios.get(route('attention.admin.api.active')).then(({ data }) => {
        attentions.value = data.attentions;
    });
};
load();
</script>
